import React from 'react';
import { DropdownItem } from 'reactstrap';
import lodash from 'lodash';
import { useTheme } from './ThemeProvider';
import Icon from '../common/containers/icon';
import ga from '../../utils/ga';
const LAYOUT_OPTIONS = [{
  value: 'top',
  label: 'Top Layout',
  icon: 'columns'
}, {
  value: 'sidebar',
  label: 'Sidebar Layout',
  icon: 'bars'
}];
const MODE_OPTIONS = [{
  value: 'classic',
  label: 'Classic',
  icon: 'palette'
}, {
  value: 'light',
  label: 'Light',
  icon: 'sun'
}, {
  value: 'dark',
  label: 'Dark',
  icon: 'moon'
}];

/**
 * Layout/mode dropdown items (used by ThemeSelectorFooter).
 */
const ThemeSelector = () => {
  const {
    layout,
    mode,
    setLayout,
    setMode
  } = useTheme();
  const handleLayoutSelect = newLayout => {
    if (newLayout !== layout) {
      setLayout(newLayout);
      ga.trackEvent('Theme', 'layout_change', newLayout);
    }
  };
  const handleModeSelect = newMode => {
    if (newMode !== mode) {
      setMode(newMode);
      ga.trackEvent('Theme', 'mode_change', newMode);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownItem, {
    header: true
  }, "Layout"), LAYOUT_OPTIONS.map(({
    value,
    label,
    icon
  }) => /*#__PURE__*/React.createElement(DropdownItem, {
    key: value,
    className: lodash.kebabCase(`t-h-nav-layout-${value}`),
    onClick: () => handleLayoutSelect(value),
    active: layout === value
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: icon,
    style: {
      marginRight: '10px'
    }
  }), label)), /*#__PURE__*/React.createElement(DropdownItem, {
    divider: true
  }), /*#__PURE__*/React.createElement(DropdownItem, {
    header: true
  }, "Mode"), MODE_OPTIONS.map(({
    value,
    label,
    icon
  }) => /*#__PURE__*/React.createElement(DropdownItem, {
    key: value,
    className: lodash.kebabCase(`t-h-nav-mode-${value}`),
    onClick: () => handleModeSelect(value),
    active: mode === value
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: icon,
    style: {
      marginRight: '10px'
    }
  }), label)));
};
export default ThemeSelector;